export default "\n<ion-app>\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n\n\n";